import { useTranslation } from 'react-i18next';
import { withProviders } from '../../../providers/with-providers';
import { Icon } from '../../foundations';
import { Text } from '../../foundations';
import { clsx } from 'clsx';
import styles from './AlertAutoCheck.module.css';
import { useState } from 'react';
import useResponsiveCollapse from '../../../helpers/hooks/useResponsiveCollapse';
import { TFunction } from 'i18next';
type ComponentsProps = { t: TFunction<['alert-auto-check', 'common']> };
const Component = () => {
	const [isCollapsed] = useResponsiveCollapse({
		underThresholdCollapsed: true,
		overThresholdCollapsed: false,
		threshold: 767
	});
	const { t } = useTranslation(['alert-auto-check', 'common']);
	if (isCollapsed) {
		return <ComponentSmallerScreens t={t} />;
	}
	return <ComponentDesktop t={t} />;
};

export const ComponentDesktop = ({ t }: ComponentsProps) => {
	return (
		<section role="alert" className={styles.alert_container}>
			<Icon name="info" className={styles.alert_icon} />
			<Text className={styles.alert_title} font="verdana" size="lg-regular">
				{t('ALERT_AUTO_CHECK')}
			</Text>
		</section>
	);
};

export const ComponentSmallerScreens = ({ t }: ComponentsProps) => {
	const [isCollapsed, setCollapsed] = useState(true);
	return (
		<section
			role="alert"
			className={clsx(styles.alert_container, styles.alert_container_mobile_collapsed, {
				[styles.alert_container_mobile_expanded]: !isCollapsed
			})}
		>
			<Icon
				name="info"
				className={clsx(styles.alert_icon_mobile_collapsed, {
					[styles.alert_icon_mobile_expanded]: !isCollapsed
				})}
			/>
			<Text
				className={clsx(styles.alert_title, {
					[styles.alert_title_mobile_collapsed]: isCollapsed,
					[styles.alert_title_mobile_expanded]: !isCollapsed
				})}
				font="verdana"
				size="md-regular"
			>
				{t('ALERT_AUTO_CHECK')}
			</Text>
			<Icon
				name="chevron-line-down"
				className={clsx(styles.alert_chevron, {
					[styles.alert_chevron_expanded]: !isCollapsed
				})}
				onClick={() => {
					setCollapsed((prevState) => !prevState);
				}}
			/>
		</section>
	);
};

export const AlertAutoCheck = withProviders(Component);
